/** Label único no menu de cadastro e no accordion da carteira. */
export const FUNDS_GROUP_LABEL = "Fundos / ETFs / Previdência";

export const displayAssetGroupName = (groupName: string): string => {
    if (groupName.startsWith("Fundos")) {
        return FUNDS_GROUP_LABEL;
    }
    return groupName;
};
